import { useMutation } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import reactQueryUtils from "../../../utils/reactQueryUtils";
import riskAssessmentService from "../../services/riskAssessmentService";

const { client } = reactQueryUtils;

// Uploads an external document as a new document-only risk assessment.
const useUploadRiskAssessment = () =>
    useMutation(riskAssessmentService.uploadRiskAssessment, {
        onSuccess: () => {
            client.invalidateQueries({ queryKey: [queryKeys.riskAssessments] });
        },
    });

export default useUploadRiskAssessment;
